// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"fb333c5b9c4a1cdc","6349":"2ea50ed0dbcd1960","6607":"a2318cbd357ffd47","6933":"6b4294927989e1c6"}[chunkId] + ".css";
};